module.exports = __webpack_public_path__ + "img/challenge-not.1291c737.png";